import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const Dashboard = () => {
  const [stats, setStats] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(true);

  const colors = {
    primary: "#1A3D63",
    darkPrimary: "#0A1932",
    lightAccent: "#B3CFE5",
    midBlue: "#4A7FA7",
    white: "#FFFFFF",
    black: "#000000",
  };
  const getGradient = (index, total) => {
    const start = 10 + index * (70 / total);
    const end = 30 + index * (70 / total);

    return `linear-gradient(135deg, hsl(215, 70%, ${start}%), hsl(200, 60%, ${end}%))`;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/getDashboard.php`,
        );

        const data = await res.json();

        setStats([
          { title: "Vsi INC", value: data.stats.all },
          { title: "Aktivni INC", value: data.stats.active },
          { title: "Rešeni INC", value: data.stats.resolved },
          { title: "Odprti INC", value: data.stats.pending },
        ]);

        setWeeklyData(data.weekly);
        setPieData(data.pie);
        setLatest(data.latest);

        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="p-5 text-center" style={{ color: colors.primary }}>
        Loading dashboard...
      </div>
    );
  }
  const gradientSteps = [
    ["#0A1932", "#1A3D63"],
    ["#1A3D63", "#2E5C86"],
    ["#2E5C86", "#4A7FA7"],
    ["#4A7FA7", "#B3CFE5"],
  ];
  return (
    <div
      className="p-3 m-2 rounded-2xl min-h-[calc(100%-1rem)]
      "
      style={{
        background: `linear-gradient(0deg, ${colors.white}, #F5F9FC)`,
      }}
    >
      <h1
        className="text-3xl font-semibold mb-5"
        style={{ color: colors.darkPrimary }}
      >
        Nadzorna plošča
      </h1>

      {/* TOP STATS */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        {stats.map((item, index) => (
          <div
            key={index}
            className="rounded-2xl p-4 h-36 shadow-md flex flex-col justify-between transition hover:scale-[1.02]"
            style={{
              background: `linear-gradient(135deg, ${
                gradientSteps[index][0]
              }, ${gradientSteps[index][1]})`,
              color: colors.white,
            }}
          >
            <span className="text-sm opacity-80">{item.title}</span>

            <div className="text-center text-4xl font-bold">{item.value}</div>
          </div>
        ))}
      </div>

      {/* GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* LEFT */}
        <div className="space-y-4">
          {/* WEEKLY */}
          <div
            className="rounded-2xl p-4 shadow-md"
            style={{ background: colors.white }}
          >
            <h2
              className="text-sm font-semibold mb-3"
              style={{ color: colors.primary }}
            >
              Prijavljeni incidenti po dnevih
            </h2>

            <div className="flex items-end justify-between h-40">
              {" "}
              {weeklyData.map((item, index) => (
                <div key={index} className="flex flex-col items-center w-full">
                  <div
                    className="rounded-full w-6 transition-all duration-300"
                    style={{
                      height: `${item.value}px`,
                      background:
                        index % 2 === 0 ? colors.primary : colors.midBlue,
                    }}
                  />
                  <span className="text-xs mt-1 text-gray-500">{item.day}</span>
                </div>
              ))}
            </div>
          </div>

          {/* LATEST INCIDENTS */}
          <div
            className="rounded-2xl p-4 shadow-md"
            style={{ background: colors.white }}
          >
            <h2
              className="text-sm font-semibold mb-3"
              style={{ color: colors.primary }}
            >
              Zadnjih 5 prijavljenih incidentov
            </h2>

            <div className="space-y-2">
              {latest.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center text-sm p-2 rounded-lg hover:bg-gray-50"
                >
                  <div className="flex items-center gap-2">
                    <div
                      className="w-5 h-5 rounded-full flex items-center justify-center text-xs"
                      style={{
                        background: colors.lightAccent,
                        color: colors.primary,
                      }}
                    >
                      👤
                    </div>

                    <span style={{ color: colors.darkPrimary }}>
                      {item.title}
                    </span>
                  </div>

                  <span className="text-xs text-gray-400">{item.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* PIE */}
        <div
          className="rounded-2xl p-4 shadow-md"
          style={{ background: colors.white }}
        >
          <div className="flex flex-wrap justify-center gap-2 text-sm mb-4">
            {pieData.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: item.color }}
                />
                <span style={{ color: colors.darkPrimary }}>{item.name}</span>
              </div>
            ))}
          </div>

          <div className="w-full h-[300px] md:h-[430px]">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  cx="50%"
                  cy="50%"
                  outerRadius="70%"
                  label
                >
                  {pieData.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
